import { Spin } from 'antd';
import styled from 'styled-components';

export const LoadingSpin = styled(Spin)`
  display: flex;
`;

export const Text = styled.span<{ $small?: boolean }>`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 0.875rem;
  color: #000;
  text-align: start;
  white-space: break-spaces;
  min-width: 80px;
`;

export const SkeletonLine = styled.div<{ width?: string; height?: string }>`
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '16px'};
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;
